import { useStowageStore } from 'src/context/StowageContext';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import usePostStowageApi from 'src/api/stowage/usePostStowageApi';
import { moveCargoOperation } from 'src/utils/stowage/stowageRotationMoveUtils';
import { deepCopyStowagePlan } from 'src/factory/Stowage/StowagePlanFactory';

export interface CargoOperationDragDropHandlers {
    handleDrop: (
        event: React.DragEvent<HTMLDivElement>,
        berthCall: RotationBerthCall,
        portCall: RotationPortCall,
        cargoOperation?: RotationCargoOperation | null
    ) => void;
    handleDragOver: (event: React.DragEvent<HTMLDivElement>) => void;
}

export const useCargoOperationDragDrop = (): CargoOperationDragDropHandlers => {
    const { activeStowagePlan } = useStowageStore();
    const { saveStowageData } = usePostStowageApi();

    const handleDrop = (
        e: React.DragEvent<HTMLDivElement>,
        targetBerthCall: RotationBerthCall,
        sourcePortCall: RotationPortCall,
        targetCargoOperation?: RotationCargoOperation | null
    ) => {
        e.preventDefault();
        e.stopPropagation();

        if (!sourcePortCall || targetBerthCall.berthId === -1) {
            return;
        }

        const cargoOperationGuid = e.dataTransfer.getData('cargoOperationGuid');
        const _stowagePlan = deepCopyStowagePlan(activeStowagePlan);
        const sourceCargoOperation = _stowagePlan.cargoOperations.find((op) => op.cargoOperationGuid === cargoOperationGuid);

        const stowagePlanChanges = moveCargoOperation(_stowagePlan, sourceCargoOperation, targetBerthCall, targetCargoOperation);

        saveStowageData(_stowagePlan, stowagePlanChanges);
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>): void => {
        event.preventDefault();
        event.stopPropagation();
    };

    return { handleDrop, handleDragOver };
};
